import styled from 'styled-components';
import { SxProps, Typography } from '@mui/material';
import { Flex } from '../Flex';
import { TextFieldProps } from '../TextField';
import { COMPONENT_SIZE_MAP } from '../../types/types';

type StyledTextFieldProps = {
  $size?: TextFieldProps['size'];
};

const Wrapper = styled(Flex)<StyledTextFieldProps>`
  border: 1px solid ${({ theme }) => theme.palette.common.gray7};
  padding: 4px 8px;
  border-radius: 8px;
  align-items: center;
  min-height: ${({ $size }) => COMPONENT_SIZE_MAP[$size || 'medium']}px;
`;

type Props = {
  className?: string;
  value?: string;
  size?: TextFieldProps['size'];
  sx?: SxProps;
};

export const TextFieldReadOnly = ({ className, sx, value, size }: Props) => (
  <Wrapper className={className} sx={sx} $size={size}>
    <Typography>{value}</Typography>
  </Wrapper>
);

export default TextFieldReadOnly;
